jQuery(document).ready(function ($) {
    //----------------------------------------------FAQ Action-----------------------------------//
    if($('.faq-question').length > 0) {
        $('.faq-question').click(function () {
            $(this).closest('.faq-list__item').toggleClass('active');
            $(this).next('.faq-answer').slideToggle(200);
        });
    }
});